import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FiFacebook, 
  FiInstagram, 
  FiMapPin,
  FiPhone,
  FiMail,
  FiClock
} from 'react-icons/fi';
import { FaXTwitter } from 'react-icons/fa6';
import { useContent } from '../context/ContentContext';
import './Footer.css';

const Footer = () => {
  const { content } = useContent();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-wave">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"></path>
        </svg>
      </div>
      
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">
            {/* Logo & Hakkında */}
            <div className="footer-brand">
              <div className="footer-logo">
                <img src="/logo.png" alt="BMK Eğitim Logo" className="footer-logo-image" />
                <div className="logo-text">
                  <span className="logo-name">{content.general?.siteName || 'BMK Eğitim'}</span>
                  <span className="logo-tagline">Başarıya Giden Yol</span>
                </div>
              </div>
              <p className="footer-about">
                {content.about?.description?.substring(0, 150) || 
                  'Uzman kadromuz ve modern eğitim anlayışımızla öğrencilerimizi başarıya taşıyoruz.'}...
              </p>
              <div className="footer-social">
                <a href={content.contact?.socialMedia?.facebook || '#'} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <FiFacebook />
                </a>
                <a href={content.contact?.socialMedia?.instagram || '#'} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <FiInstagram />
                </a>
                <a href={content.contact?.socialMedia?.twitter || '#'} target="_blank" rel="noopener noreferrer" aria-label="X">
                  <FaXTwitter />
                </a>
              </div>
            </div>

            {/* Hızlı Linkler */}
            <div className="footer-links">
              <h4>Hızlı Linkler</h4>
              <ul>
                <li><Link to="/">Ana Sayfa</Link></li>
                <li><Link to="/hakkimizda">Hakkımızda</Link></li>
                <li><Link to="/programlar">Eğitim Programları</Link></li>
                <li><Link to="/bursluluk">Bursluluk Sınavı</Link></li>
                <li><Link to="/galeri">Galeri</Link></li>
                <li><Link to="/iletisim">İletişim</Link></li>
              </ul>
            </div>

            {/* Programlar */}
            <div className="footer-links">
              <h4>Programlarımız</h4>
              <ul>
                {(content.services?.programs || content.services?.items || [
                  { title: 'LGS Hazırlık' },
                  { title: 'YKS-TYT-AYT' },
                  { title: 'Yabancı Dil' },
                  { title: 'Kodlama & Robotik' },
                  { title: 'Etüt Programları' }
                ]).slice(0, 5).map((program, index) => (
                  <li key={index}>
                    <Link to="/programlar">{program.title}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* İletişim */}
            <div className="footer-contact">
              <h4>İletişim</h4>
              <ul>
                <li>
                  <FiMapPin />
                  <span>{content.contact?.address || 'Atatürk Caddesi No: 123, Merkez/İstanbul'}</span>
                </li>
                <li>
                  <FiPhone />
                  <a href={`tel:${content.contact?.phone}`}>{content.contact?.phone || '0212 123 45 67'}</a>
                </li>
                <li>
                  <FiMail />
                  <a href={`mailto:${content.contact?.email}`}>{content.contact?.email || 'info@bmkegitim.com'}</a>
                </li>
                <li>
                  <FiClock />
                  <span>{content.contact?.workingHours || 'Pzt - Cmt: 09:00 - 21:00'}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>&copy; {currentYear} {content.general?.siteName || 'BMK Eğitim Kurumları'}. Tüm hakları saklıdır.</p>
          <div className="footer-bottom-links">
            <Link to="/gizlilik-politikasi">Gizlilik Politikası</Link>
            <Link to="/kvkk">KVKK</Link>
            <Link to="/admin/login">Yönetim</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

